import { apiGet, apiPatch, apiPost } from '../standardApi';

export async function apiGetAllCategories(silently) {
  const response = await apiGet(
    `/Documents/Categories`,
    'application/json',
    silently
  );
  if (response.status === 200) {
    response.data = response.data.map((item) => {
      item.name = item.name.replace('_Devis', '');
      return item;
    });
  }
  return response;
}

export async function apiGetGaranties(contract) {
  const response = await apiGet(
    `/Contracts/Warranty/${contract}`,
    'application/json'
  );
  return response;
}

export async function apiGetCategoriesById(id) {
  const response = await apiGet(
    `/Documents/GetCategory/${id}`,
    'application/json'
  );
  return response;
}

export async function apiGetSentDocuments() {
  const response = await apiGet(`/Documents/SentDocuments`, 'application/json');
  return response;
}
export async function apiPostSendDocument(data) {
  const response = await apiPost(
    '/Documents/SendDocument',
    data,
    '',
    'form-data'
  );
  return response;
}
export async function apiGetCgrmDocuments() {
  const response = await apiGet(
    `/Documents/GetAllSentDocuments?StartDate=01/01/2012&EndDate=01/31/${
      new Date().getFullYear() + 1
    }`,
    'application/json'
  );
  return response;
}

export async function apiGetCGRMAttenteDocumentByNumFic(numFic) {
  const response = await apiGet(
    `/Documents/GetCGRMAttenteDocumentByNumFic/${numFic}`,
    'application/json'
  );
  return response;
}

export async function apiGetSpvieDocument(AttachmentId) {
  const response = await apiGet(
    `/Documents/GetSpvieDocument/${AttachmentId}`,
    'application/json'
  );
  return response;
}

export async function apiGetCGRMIndexedDocumentByNumFic(numFic) {
  const response = await apiGet(
    `/Documents/GetCGRMIndexedDocumentByNumFic/${numFic}`,
    'application/json'
  );
  return response;
}

export async function apiGetSpVieDocument(id) {
  const response = await apiGet(
    `/Documents/GetSpVieDocument/${id}`,
    'application/json'
  );
  return response;
}

export async function apiGetDocumentsById(id) {
  const response = await apiGet(
    `/Documents/GetDocuments?categoryId=${id}`,
    'application/json'
  );
  return response;
}
